import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { CaseConvert } from '../utils/case-convert';
import { SUPPRESS_ERROR, SUPPRESS_ERROR_CODES } from '../utils/httpContextTokens';
import { ErrorAlertService } from 'src/app/services';

export class ApiError {
  status: number;
  messages: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private errorAlertService: ErrorAlertService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          const apiError = new ApiError();
          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred.
            apiError.status = error.status;
            apiError.messages = [error.error.message];
          } else {
            // this is server side error
            const contentType = error.headers.get('content-type');
            apiError.status = error.status;
            if (contentType != null && contentType.startsWith('application/json')) {
              const err = CaseConvert.keysToCamel(error.error);
              apiError.messages = err.messages || [err.message];
            } else {
              apiError.messages = [error.statusText];
            }
          }
          var suppressError = request.context.get(SUPPRESS_ERROR) || request.context.get(SUPPRESS_ERROR_CODES).has(error.status);
          if (suppressError) {
            console.error($localize`:@@errorMessageHttp:Error Code: ${apiError.status}, Messages: ${apiError.messages}`)
          } else {
            this.errorAlertService.showError(apiError.messages);
          }
          return throwError(apiError);
        })
      );
  }
}
